import React from 'react';
import RevealText from '../components/RevealText';

const Quote = ({ scriptText, normalText, author }) => {
  return (
    // This container provides the full-width background
    <div className="quote-container">
      {/* This wrapper constrains the content's width for readability */}
      <div className="quote-wrapper">
        <div className="quote-icon">“</div>
        <blockquote className="quote-content">
          <RevealText className="quote-script-text" text={scriptText} speed={0.05} />
          
          <p className="quote-normal-text">{normalText}</p>
        </blockquote>
        <footer className="quote-author">— {author}</footer>
      </div>
    </div>
  );
};

export default Quote;